import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, OnInit, } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2'
import { InsuredService } from '@services/insured.service';
import { NgbModal, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { CoreModule } from 'app/modules/core.module';
import { ContractedPoliciesComponent } from './contracted-policies/contracted-policies.component';
import { PersonalInformationComponent } from './personal-information/personal-information.component';
import { AdditionalsComponent } from './additionals/additionals.component';
import { IncorporationComponent } from './incorporation/incorporation.component';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NumberPipe } from 'app/pipes/number.pipe';
import { BankAccountViewComponent } from './bank-account-view/bank-account-view.component';

@Component({
  selector: 'app-insured',
  standalone: true,
  imports: [NumberPipe, ContractedPoliciesComponent, AdditionalsComponent, PersonalInformationComponent, IncorporationComponent, BankAccountViewComponent, NgbNavModule, CoreModule, NgSelectComponent],
  providers: [InsuredService],
  templateUrl: './insured.component.html',
  styleUrls: ['./insured.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InsuredComponent implements OnInit {

  private destroyRef = inject(DestroyRef)
  private cdr = inject(ChangeDetectorRef)
  private _insuredService = inject(InsuredService)
  private modalService = inject(NgbModal)
  private _fb = inject(FormBuilder)
  private userInfo: any
  private modalOptions = {
    size: 'xl',
    scrollable: true,
    animation: true,
    backdrop: null
  }

  public tab = "search-insured"
  public rut: string = ""
  public insuredModel: any
  public newInsured: any

  protected policySel: any
  protected searchByFilter = ["RUT", "Nombre"]
  protected searchBy = this.searchByFilter[0]
  protected insuredList = []
  protected searched = false

  public Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    width: 500,
    timerProgressBar: true
  })


  ngOnInit(): void {

  }

  setNewInsured() {
    this.newInsured = true
  }

  checkInsured() {
    if (this.insuredModel != null) {
      Swal.fire({
        title: "Al aceptar, perderá toda la información del socio",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed == true) {
          this.insuredModel = null
          this.rut = ''
        } else {
          this.tab = "personal-information";
        }
      })
    }



  }

  searchInsured() {
    if (this.rut.trim().length > 0) {
      this.searched = true
      Swal.fire({
        text: "Cargando Datos...",
        didOpen: () => {
          Swal.showLoading()
        }
      })
      if (this.searchBy == "RUT") {
        const isValid = this.validRutSearch(this.rut)
        if (isValid) this.searchByRUT()
        else this.Toast.fire({
          title: "Formato RUT inválido. Use formato chileno (ej: 12.345.678-9)",
          icon: "warning"
        })
      } else {
        this.searchByName()
      }
    } else {
      this.Toast.fire({
        title: "Debe ingresar un valor para buscar",
        icon: "info"
      })
    }

  }

  setInsured(insured: any) {
    this.insuredModel = insured
  }

  searchByRUT() {
    const rutClean = this.cleanRut(this.rut)
    this._insuredService.getInsuredByRut(rutClean).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (res) => {
        if (res) {
          this.insuredList = res
          if (this.insuredList.length == 1) this.setInsured(this.insuredList[0])
          Swal.close()
          this.cdr.markForCheck()
        } else {
          this.Toast.fire({
            title: "No se Encontraron Registros",
            icon: "info"
          })
        }
      },
      error: (err) => { console.error('Error searching by RUT', err); Swal.close(); this.Toast.fire({ title: 'Error al buscar por RUT', icon: 'error' }) }
    })
  }

  searchByName() {

    this._insuredService.getInsuredByName(this.rut).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res) => {
      if (res) {
        this.insuredList = res
        Swal.close()
        this.cdr.markForCheck()
      } else {
        this.Toast.fire({
          title: "No se Encontraron Registros",
          icon: "info"
        })
      }


    }, (err) => {
      Swal.close()
      this.Toast.fire({
        title: err.error.msg,
        icon: err.status === 404 ? "info" : "error"
      })
    })
  }

  policySelected(policy: any) {
    this.policySel = policy
  }

  updateInsured(event: any) {
    this.insuredModel = event
  }

  changeInsured(rut: any) {
    this.tab = "search-insured"
    this.rut = rut
    this.searched = true
    this.searchByRUT()
  }
  validRutSearch(rut: string): boolean {
    const cleaned = rut.replace(/\./g, '').trim()
    return /^\d{7,8}-?[\dkK]?$/.test(cleaned)
  }

  cleanRut(rut: string): string {
    return rut.replace(/\./g, '').split('-')[0]
  }
}
